import {
    Component,
    Input,
    OnInit,
    ViewChild,
    ViewContainerRef,
    Type,
} from '@angular/core';
import { IDrawerSlot } from '../filter-drawer.types';
import { NumberSlotComponent } from './number-slot/number-slot.component';
import { SelectSlotComponent } from './select-slot/select-slot.component';
import { DateSlotComponent } from './date-slot/date-slot.component';
import { TextSlotComponent } from './text-slot/text-slot.component';
import { DateRangeSlotComponent } from './date-range-slot/date-range-slot.component';
import { DateRangeWithTimeSlotComponent } from './date-range-with-time-slot/date-range-with-time-slot.component';
import { MultiSelectSlotComponent } from './multi-select-slot/multi-select-slot.component';
import { ComboboxSlotComponent } from './combobox-slot/combobox-slot.component';

const componentMap: { [key: string]: Type<any> } = {
    number: NumberSlotComponent,
    select: SelectSlotComponent,
    date: DateSlotComponent,
    text: TextSlotComponent,
    'date-range': DateRangeSlotComponent,
    'date-range-with-time': DateRangeWithTimeSlotComponent,
    'multi-select': MultiSelectSlotComponent,
    combobox: ComboboxSlotComponent,
};
@Component({
    selector: 'slot-loader',
    template: '<ng-template #slotContainer></ng-template>',
    standalone: true,
})
export class SlotLoaderComponent implements OnInit {
    @Input() slot!: IDrawerSlot;
    @Input() formGroup!: any;
    @ViewChild('slotContainer', { read: ViewContainerRef, static: true })
    slotContainer!: ViewContainerRef;

    ngOnInit(): void {
        this.loadSlotComponent();
    }

    async loadSlotComponent() {
        const component = this.getComponentType(this.slot.type);
        if (component) {
            const componentRef = this.slotContainer.createComponent(component);
            componentRef.instance.slot = this.slot;
            componentRef.instance.formGroup = this.formGroup;
        }
    }
    
    
    private getComponentType(type: string): Type<any> | null {
        return componentMap[type] || null;
    }

    //todo: find dynamic import for angular 18.
    // private async getComponentType(type: string): Promise<Type<any> | null> {
    //     try {
    //         const module = await import(
    //             `./${type}-slot/${type}-slot.component`
    //         );
    //         return module[`${this.toPascalCase(type)}SlotComponent`];
    //     } catch (error) {
    //         console.error('Error loading component:', error);
    //         return null;
    //     }
    // }

    // private toPascalCase(string: string): string {
    //     return string
    //         .split(/[-_\s]+/)
    //         .map(
    //             (word) =>
    //                 word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
    //         )
    //         .join('');
    // }
}
